import Image from "next/image";
import LikeComment from "./likeComment";
import { ConditionName, ISingleReplyProps } from "interfaces";
import { conditions, getRemainingTime } from "helpers";
import dynamic from "next/dynamic";
import useLongPress from "helpers/hooks/useLongPress";
import CommentSettingsPopover from "./commentSettings/commentSettingsPopover";
import { isShowCommentSettings } from "redux-share/actions";
import CommentSettingsInDesktop from "./commentSettings/commentSettingsInDesktop";

const EmptyProfileIcon = dynamic(() => import("../../icon-components/emptyProfile"));

const SingleReply = ({ replies, setReplies, reply, usersRepliesProfiles, commentsLocalStorageIds, setRepliesCount }: ISingleReplyProps) => {
    const user = usersRepliesProfiles.find((user: any) => user.id === reply.author);
    const { handleTouchStart, handleTouchEnd, isLongPress, setIsLongPress, touchPosition } = useLongPress("popover-content");

    return (
        <div className="pl-relative">
            <div className="pl-w-full pl-px-4 pl-pt-4 pl-relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                <div className="pl-flex pl-justify-between pl-items-center pl-w-full">
                    <div className="pl-flex pl-items-center pl-gap-1 pl-text-[11px] pl-font-normal">
                        {user && Object.keys(user).length > 0 && user.image ? (
                            <Image src={user.image} width={24} height={24} alt="user-profile" className="pl-rounded-full" />
                        ) : (
                            <EmptyProfileIcon />
                        )}
                        <p className="pl-text-main-highLight">
                            {user && Object.keys(user).length > 0 && user.displayName ? user.displayName : "کاربر ناشناس"} .
                        </p>
                        <span className="pl-text-z-gray-400">{getRemainingTime(reply.created_at)}</span>
                    </div>
                    <div className="pl-flex pl-items-center pl-gap-3">
                        <LikeComment
                            commentId={reply.id}
                            likesCount={reply.like}
                            isIdInLocalStorage={!!commentsLocalStorageIds && commentsLocalStorageIds.includes(reply.id)}
                        />
                        {!conditions(ConditionName.isTouchScreen) && isShowCommentSettings(reply.author) && (
                            <CommentSettingsInDesktop
                                commentId={reply.id}
                                isReply={true}
                                replies={replies}
                                setReplies={setReplies}
                                setRepliesCount={setRepliesCount}
                            />
                        )}
                    </div>
                </div>
                <p className="pl-text-[13px] pl-font-normal pl-leading-[22px] pl-mb-1 pl-text-z-gray-700 dark:pl-text-secondary-50">{reply.text}</p>
            </div>
            {conditions(ConditionName.isTouchScreen) && isShowCommentSettings(reply.author) && isLongPress && (
                <CommentSettingsPopover
                    setShowPopover={setIsLongPress}
                    isReply={true}
                    commentId={reply.id}
                    replies={replies}
                    setReplies={setReplies}
                    setRepliesCount={setRepliesCount}
                    touchPosition={touchPosition}
                />
            )}
        </div>
    );
};

export default SingleReply;
